import { createTheme } from '@material-ui/core/styles';
import defaultTheme from './default';

const overrides = {
    typography: {
        h1: {
            fontSize: '2.1rem'
        },
        h2: {
            fontSize: '1.4rem'
        },
        h3: {
            fontSize: '1.148rem'
        },
        h4: {
            fontSize: '1.049rem'
        },
        h5: {
            fontSize: '0.956rem'
        },
        h6: {
            fontSize: '0.8rem'
        }
    }
};

const themes = {
    default: createTheme({ ...defaultTheme, ...overrides })
};

export default themes;
